import axios from 'axios';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || (import.meta.env.DEV ? 'http://localhost:8000' : 'https://authentiqueartifice.com/backend')
});

// API INTERFACE
export const apiService = {
  getProducts: (params = {}) => {
    return api.get('/get_products.php', { params }).then(res => {
      if (Array.isArray(res.data)) {
        res.data = res.data.map(p => ({
          ...p,
          price: parseFloat(p.price) || 0,
          duration: parseInt(p.duration) || 30
        }));
      }
      return res;
    });
  },
  getProduct: (slug) => {
    return api.get('/get_products.php', { params: { slug } }).then(res => {
      if (res.data && !res.data.error) {
        res.data.price = parseFloat(res.data.price) || 0;
        res.data.duration = parseInt(res.data.duration) || 30;
      }
      return res;
    });
  },
  getCategories: () => {
    return api.get('/get_categories.php');
  },
  getShippingCost: (totalWeight, totalAmount) => {
    return api.get('/get_shipping_cost.php', { params: { total_weight: totalWeight, total_amount: totalAmount } });
  }
};

// Global interceptor for backward compatibility with components using api.get('/products')
const originalGet = api.get;
api.get = function (url, config = {}) {
  if (url === '/products') return apiService.getProducts(config.params);
  if (url.startsWith('/products/')) {
    const slug = url.split('/products/')[1];
    return apiService.getProduct(slug);
  }
  if (url === '/categories') return apiService.getCategories();
  return originalGet.apply(this, arguments);
};

export default api;
